import React, { useState, useEffect } from "react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "../../components/Custom/Grid/GridContainer";
import GridItem from "../../components/Custom/Grid/GridItem";
import DoughnutChart from "./DoughnutChart";
import BarChart from "./BarChart";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ReceiptIcon from "@material-ui/icons/Receipt";
import RestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import RefundIcon from "@material-ui/icons/RemoveShoppingCart";
import PaymentIcon from "@material-ui/icons/Payment";
import ApiService from "../../ApiService";
import PageTitle from "../../components/PageTitle";
//import dayjs from "dayjs";
import {
  Avatar,
  CardHeader,
  Card,
  Typography,
  /* Paper, */ CircularProgress,
  Backdrop,
  Paper,
} from "@material-ui/core/";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Button,
  Alert,
} from "@mui/material";

const useStyles = makeStyles((theme) => ({
  avatarCheck: {
    backgroundColor: "rgb(35, 75, 119)",
  },
  avataSett: {
    backgroundColor: "rgb(173, 206, 171)",
  },
  avataChbk: {
    backgroundColor: "rgb(153, 65, 65)",
  },
  avataRefund: {
    backgroundColor: "rgba(239, 192, 4, 0.91)",
  },
  avataDecline: {
    backgroundColor: " #ad4e91",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  card: {
    border: "1px solid #e0e0e0",
  },
}));

const dayjs = require("dayjs");

let curdt = dayjs();
let formatedDt = curdt.format("YYYYMMDD");

const getMonth = (month) => {
  const monthAgo = curdt.subtract(month, "month").add(1, "day");
  const monthAgoFormattedDate = monthAgo.format("YYYYMMDD");
  return monthAgoFormattedDate;
};

export default function DashboardComponent() {
  const classes = useStyles();
  const [txnSummary, setTxnSummary] = useState();
  const [monthSummary, setMonthSummary] = useState();
  const [open, setOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState("lastMonth");
  const [currency, setCurrency] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [date, setDate] = useState(getMonth(1));
  const [currentDate, setCurrentDate] = useState(formatedDt);
  const [responseMessage, setResponseMessage] = useState(null);
  const [failed, setFailed] = useState(false);
  const [success, setSuccess] = useState(false);
  const [currencySign, setCurrencySign] = useState(`$`);

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const getCurrencySign = (currency) => {
    switch (currency) {
      case "USD":
        setCurrencySign(`$`);
        break;
      case "EUR":
        setCurrencySign(`€`);
        break;
      case "GBP":
        setCurrencySign(`£`);
        break;
      case "NGN":
        setCurrencySign(`₦`);
        break;
      case "INR":
        setCurrencySign(`₹`);
        break;
      default:
        setCurrencySign(`$`);
        break;
    }
  };

  const handleCurrencyChange = async (event) => {
    setSelectedCurrency(event.target.value);
    await reloadTxnStatusData(date, currentDate, event.target.value);
    await reloadMonthsTxnData(date, currentDate, event.target.value);
    getCurrencySign(event.target.value);
  };

  const reloadTxnStatusData = async (
    dt = date,
    currDt = currentDate,
    selCurr = selectedCurrency
  ) => {
    await ApiService.fetchTxnStatusSummary(dt, currDt, selCurr)
      .then((res) => {
        setTxnSummary(res.data);
      })
      .catch((e) => {});
  };

  const reloadMonthsTxnData = async (
    dt = date,
    currDt = currentDate,
    selCurr = selectedCurrency
  ) => {
    await ApiService.fetchMonthsTxnSummary(dt, currDt, selCurr)
      .then((res) => {
        setMonthSummary(res.data.responseObject);
      })
      .catch((e) => {});
  };

  const handlePeriodChange = async (event) => {
    let finalDate;
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "lastMonth":
        const thirtyDaysAgo = getMonth(1);
        setDate(thirtyDaysAgo);
        finalDate = thirtyDaysAgo;

        break;

      case "last3Months":
        const threeMonthsAgo = getMonth(3);
        setDate(threeMonthsAgo);
        finalDate = threeMonthsAgo;
        break;

      case "last6Months":
        const sixMonthsAgo = getMonth(6);
        setDate(sixMonthsAgo);
        finalDate = sixMonthsAgo;
        break;

      case "last12Months":
        const twelveMonthsAgo = getMonth(12);
        setDate(twelveMonthsAgo);
        finalDate = twelveMonthsAgo;
        break;

      default:
        break;
    }
    await reloadTxnStatusData(finalDate, formatedDt, selectedCurrency);
    await reloadMonthsTxnData(finalDate, formatedDt, selectedCurrency);
  };
  useEffect(() => {
    handleToggle();
    reloadTxnStatusData();
    reloadMonthsTxnData();
    const txnFn = async () => {
      // const t1 = await ApiService.fetchTxnStatusSummary();
      // const t2 = await ApiService.fetchMonthsTxnSummary();
      const t3 = await ApiService.fetchCurrency();

      // setTxnSummary(t1.data);
      // setMonthSummary(t2.data);
      setCurrency(t3.data);
      handleClose();
    };
    txnFn();
  }, []);
  return (
    <>
      <Paper style={{ margin: "1em", padding: "1em" }}>
        <GridContainer justifyContent="flex-start" style={{ marginLeft: "1%" }}>
          <PageTitle title=" Admin Dashboard" />
          <Backdrop
            className={classes.backdrop}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid style={{ marginLeft: "43%" }} item xs={12} sm={6} md={3} lg={2}>
            <FormControl
              variant="standard"
              style={{ width: "100%", marginTop: "3%" }}
            >
              <InputLabel id="demo-simple-select-label">
                Select Period
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedOption}
                onChange={handlePeriodChange}
                style={{ fontSize: "12px", color: "#637562" }}
              >
                <MenuItem
                  value="lastMonth"
                  style={{ fontSize: "12px", color: "#637562" }}
                >
                  Last Month
                </MenuItem>
                <MenuItem
                  value="last3Months"
                  style={{ fontSize: "12px", color: "#637562" }}
                >
                  Last 3 Months
                </MenuItem>
                <MenuItem
                  value="last6Months"
                  style={{ fontSize: "12px", color: "#637562" }}
                >
                  Last 6 Months
                </MenuItem>
                <MenuItem
                  value="last12Months"
                  style={{ fontSize: "12px", color: "#637562" }}
                >
                  Last 12 Months
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl
              variant="standard"
              style={{ width: "100%", marginLeft: "17%", marginTop: "3%" }}
            >
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                labelId="currency-label"
                id="currency-select"
                value={selectedCurrency}
                onChange={handleCurrencyChange}
                style={{ fontSize: "12px", color: "#637562" }}
              >
                {currency &&
                  currency.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item}
                      style={{ fontSize: "12px", color: "#637562" }}
                    >
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3} lg={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClick}
              style={{ marginTop: 12 }}
            >
              Search
            </Button>
          </Grid> */}
        </GridContainer>

        <GridContainer
          justifyContent="space-evenly"
          style={{ margin: ".5em", padding: ".5em" }}
        >
          <GridItem
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ marginTop: "14px", padding: 0 }}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Avatar
                    aria-label="Successful"
                    className={classes.avatarCheck}
                  >
                    <CheckCircleIcon />
                  </Avatar>
                }
                title="Successful"
                subheader={
                  <>
                    <Typography variant="caption">
                      {" "}
                      {currencySign}
                      {txnSummary &&
                        txnSummary.responseObject.successfulTxnAmount.toFixed(
                          2
                        )}
                    </Typography>
                    <br />
                    <Typography noWrap variant="caption">
                      {" "}
                      Count:{" "}
                      {txnSummary &&
                        txnSummary.responseObject.successfulTxnCount}
                    </Typography>
                  </>
                }
              />
            </Card>
          </GridItem>
          <GridItem
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ marginTop: "14px", padding: 0 }}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Avatar aria-label="Settled" className={classes.avataSett}>
                    <ReceiptIcon />
                  </Avatar>
                }
                title="Settled"
                subheader={
                  <>
                    <Typography variant="caption">
                      {" "}
                      {currencySign}
                      {txnSummary &&
                        txnSummary.responseObject.successfulSettledAmount.toFixed(
                          2
                        )}
                    </Typography>
                    <br />
                    <Typography noWrap variant="caption">
                      {" "}
                      Count:{" "}
                      {txnSummary &&
                        txnSummary.responseObject.successfulSettledCount}
                    </Typography>
                  </>
                }
              />
            </Card>
          </GridItem>
          <GridItem
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ marginTop: "14px", padding: 0 }}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Avatar aria-label="Decline" className={classes.avataDecline}>
                    <PaymentIcon />
                  </Avatar>
                }
                title="Decline"
                subheader={
                  <>
                    <Typography variant="caption">
                      {" "}
                      {currencySign}
                      {txnSummary &&
                        txnSummary.responseObject.declinedTxnAmount.toFixed(2)}
                    </Typography>
                    <br />
                    <Typography noWrap variant="caption">
                      {" "}
                      Count:{" "}
                      {txnSummary && txnSummary.responseObject.declinedTxnCount}
                    </Typography>
                  </>
                }
              />
            </Card>
          </GridItem>
          <GridItem
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ marginTop: "14px", padding: 0 }}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Avatar aria-label="Chargeback" className={classes.avataChbk}>
                    <RefundIcon />
                  </Avatar>
                }
                title="Chargeback"
                subheader={
                  <>
                    <Typography variant="caption">
                      {" "}
                      {currencySign}
                      {txnSummary &&
                        txnSummary.responseObject.chbkTxnAmount.toFixed(2)}
                    </Typography>
                    <br />
                    <Typography noWrap variant="caption">
                      {" "}
                      Count:{" "}
                      {txnSummary && txnSummary.responseObject.chbkTxnCount}
                    </Typography>
                  </>
                }
              />
            </Card>
          </GridItem>
          <GridItem
            xs={12}
            sm={6}
            md={4}
            lg={2}
            style={{ marginTop: "14px", padding: 0 }}
          >
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Avatar aria-label="Refund" className={classes.avataRefund}>
                    <RestoreIcon />
                  </Avatar>
                }
                title="Refund"
                subheader={
                  <>
                    <Typography variant="caption">
                      {" "}
                      {currencySign}
                      {txnSummary &&
                        txnSummary.responseObject.refundTxnAmount.toFixed(2)}
                    </Typography>
                    <br />
                    <Typography noWrap variant="caption">
                      {" "}
                      Count:{" "}
                      {txnSummary && txnSummary.responseObject.refundTxnCount}
                    </Typography>
                  </>
                }
              />
            </Card>
          </GridItem>
        </GridContainer>

        <GridContainer justifyContent="flex-start">
          <GridItem
            xs={12}
            sm={12}
            md={6}
            lg={5}
            style={{ marginTop: "30px", marginLeft: "4%" }}
          >
            <BarChart monthSummary={monthSummary} />
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={6}
            lg={5}
            style={{ marginTop: "30px", marginLeft: "6%" }}
          >
            <DoughnutChart txnSummary={txnSummary} />
          </GridItem>
          <Backdrop
            className={classes.backdrop}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </GridContainer>
      </Paper>
    </>
  );
}
